module.exports = __webpack_public_path__ + "static/1270104024-wide.a8950e44.jpg";